/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './AiAgentInstancesChirpServiceV2';
import * as Queries from './AiAgentInstancesChirpServiceV2.dfc.new';
import type { AdditionalContextArgs } from './AiAgentInstancesChirpServiceV2.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetAgentInstanceQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentInstanceResponseType>,
    References.GetAgentInstanceRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getAgentInstance', References.GetAgentInstanceResponseType>
        : References.GetAgentInstanceResponseType)
    | undefined;
};

export function useGetAgentInstanceQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentInstanceResponseType>,
    References.GetAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstanceQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_AGENT_INSTANCE_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstanceQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetAgentInstanceQueryReturn<T>;
}

type UseGetAgentInstanceLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentInstanceResponseType>,
    References.GetAgentInstanceRequestType,
    T extends true
      ? Record<'getAgentInstance', References.GetAgentInstanceResponseType>
      : References.GetAgentInstanceResponseType
  >;

export function useGetAgentInstanceLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentInstanceResponseType>,
    References.GetAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstanceLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_INSTANCE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentInstanceLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentInstanceLazyQueryReturn<T>;
}

type UseGetAgentInstanceSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAgentInstanceResponseType>,
    References.GetAgentInstanceRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getAgentInstance', References.GetAgentInstanceResponseType>
    : References.GetAgentInstanceResponseType;
};

export function useGetAgentInstanceSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentInstanceResponseType>,
    References.GetAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstanceSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_INSTANCE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstanceSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstanceSuspenseQueryReturn<T>;
}

type UseGetAgentInstancesByIDsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentInstancesByIDsResponseType>,
    References.GetAgentInstancesByIDsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAgentInstancesByIDs',
            References.GetAgentInstancesByIDsResponseType
          >
        : References.GetAgentInstancesByIDsResponseType)
    | undefined;
};

export function useGetAgentInstancesByIDsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentInstancesByIDsResponseType>,
    References.GetAgentInstancesByIDsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesByIDsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AGENT_INSTANCES_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesByIDs: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesByIDsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesByIDsQueryReturn<T>;
}

type UseGetAgentInstancesByIDsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentInstancesByIDsResponseType>,
    References.GetAgentInstancesByIDsRequestType,
    T extends true
      ? Record<
          'getAgentInstancesByIDs',
          References.GetAgentInstancesByIDsResponseType
        >
      : References.GetAgentInstancesByIDsResponseType
  >;

export function useGetAgentInstancesByIDsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentInstancesByIDsResponseType>,
    References.GetAgentInstancesByIDsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesByIDsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_INSTANCES_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesByIDs: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentInstancesByIDsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentInstancesByIDsLazyQueryReturn<T>;
}

type UseGetAgentInstancesByIDsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAgentInstancesByIDsResponseType>,
    References.GetAgentInstancesByIDsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAgentInstancesByIDs',
        References.GetAgentInstancesByIDsResponseType
      >
    : References.GetAgentInstancesByIDsResponseType;
};

export function useGetAgentInstancesByIDsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentInstancesByIDsResponseType>,
    References.GetAgentInstancesByIDsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesByIDsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_INSTANCES_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesByIDs: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesByIDsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesByIDsSuspenseQueryReturn<T>;
}

type UseGetAgentInstancesMetadataByIDsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentInstancesMetadataByIDsResponseType>,
    References.GetAgentInstancesMetadataByIDsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAgentInstancesMetadataByIDs',
            References.GetAgentInstancesMetadataByIDsResponseType
          >
        : References.GetAgentInstancesMetadataByIDsResponseType)
    | undefined;
};

export function useGetAgentInstancesMetadataByIDsQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentInstancesMetadataByIDsResponseType>,
    References.GetAgentInstancesMetadataByIDsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesMetadataByIDsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesMetadataByIDs: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesMetadataByIDsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesMetadataByIDsQueryReturn<T>;
}

type UseGetAgentInstancesMetadataByIDsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentInstancesMetadataByIDsResponseType>,
    References.GetAgentInstancesMetadataByIDsRequestType,
    T extends true
      ? Record<
          'getAgentInstancesMetadataByIDs',
          References.GetAgentInstancesMetadataByIDsResponseType
        >
      : References.GetAgentInstancesMetadataByIDsResponseType
  >;

export function useGetAgentInstancesMetadataByIDsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentInstancesMetadataByIDsResponseType>,
    References.GetAgentInstancesMetadataByIDsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesMetadataByIDsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesMetadataByIDs: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentInstancesMetadataByIDsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentInstancesMetadataByIDsLazyQueryReturn<T>;
}

type UseGetAgentInstancesMetadataByIDsSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAgentInstancesMetadataByIDsResponseType>,
      References.GetAgentInstancesMetadataByIDsRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAgentInstancesMetadataByIDs',
          References.GetAgentInstancesMetadataByIDsResponseType
        >
      : References.GetAgentInstancesMetadataByIDsResponseType;
  };

export function useGetAgentInstancesMetadataByIDsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentInstancesMetadataByIDsResponseType>,
    References.GetAgentInstancesMetadataByIDsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesMetadataByIDsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesMetadataByIDs: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesMetadataByIDsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesMetadataByIDsSuspenseQueryReturn<T>;
}

type UseGetAgentInstancesWithSnapshotsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentInstancesWithSnapshotsResponseType>,
    References.GetAgentInstancesWithSnapshotsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAgentInstancesWithSnapshots',
            References.GetAgentInstancesWithSnapshotsResponseType
          >
        : References.GetAgentInstancesWithSnapshotsResponseType)
    | undefined;
};

export function useGetAgentInstancesWithSnapshotsQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentInstancesWithSnapshotsResponseType>,
    References.GetAgentInstancesWithSnapshotsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesWithSnapshotsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesWithSnapshots: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesWithSnapshotsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesWithSnapshotsQueryReturn<T>;
}

type UseGetAgentInstancesWithSnapshotsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentInstancesWithSnapshotsResponseType>,
    References.GetAgentInstancesWithSnapshotsRequestType,
    T extends true
      ? Record<
          'getAgentInstancesWithSnapshots',
          References.GetAgentInstancesWithSnapshotsResponseType
        >
      : References.GetAgentInstancesWithSnapshotsResponseType
  >;

export function useGetAgentInstancesWithSnapshotsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentInstancesWithSnapshotsResponseType>,
    References.GetAgentInstancesWithSnapshotsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesWithSnapshotsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesWithSnapshots: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentInstancesWithSnapshotsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentInstancesWithSnapshotsLazyQueryReturn<T>;
}

type UseGetAgentInstancesWithSnapshotsSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAgentInstancesWithSnapshotsResponseType>,
      References.GetAgentInstancesWithSnapshotsRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAgentInstancesWithSnapshots',
          References.GetAgentInstancesWithSnapshotsResponseType
        >
      : References.GetAgentInstancesWithSnapshotsResponseType;
  };

export function useGetAgentInstancesWithSnapshotsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentInstancesWithSnapshotsResponseType>,
    References.GetAgentInstancesWithSnapshotsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesWithSnapshotsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesWithSnapshots: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesWithSnapshotsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesWithSnapshotsSuspenseQueryReturn<T>;
}

type UseGetAgentInstancesByWorkflowIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentInstancesByWorkflowIdResponseType>,
    References.GetAgentInstancesByWorkflowIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAgentInstancesByWorkflowId',
            References.GetAgentInstancesByWorkflowIdResponseType
          >
        : References.GetAgentInstancesByWorkflowIdResponseType)
    | undefined;
};

export function useGetAgentInstancesByWorkflowIdQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentInstancesByWorkflowIdResponseType>,
    References.GetAgentInstancesByWorkflowIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesByWorkflowIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesByWorkflowId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesByWorkflowIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesByWorkflowIdQueryReturn<T>;
}

type UseGetAgentInstancesByWorkflowIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentInstancesByWorkflowIdResponseType>,
    References.GetAgentInstancesByWorkflowIdRequestType,
    T extends true
      ? Record<
          'getAgentInstancesByWorkflowId',
          References.GetAgentInstancesByWorkflowIdResponseType
        >
      : References.GetAgentInstancesByWorkflowIdResponseType
  >;

export function useGetAgentInstancesByWorkflowIdLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentInstancesByWorkflowIdResponseType>,
    References.GetAgentInstancesByWorkflowIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesByWorkflowIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesByWorkflowId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentInstancesByWorkflowIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentInstancesByWorkflowIdLazyQueryReturn<T>;
}

type UseGetAgentInstancesByWorkflowIdSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAgentInstancesByWorkflowIdResponseType>,
      References.GetAgentInstancesByWorkflowIdRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAgentInstancesByWorkflowId',
          References.GetAgentInstancesByWorkflowIdResponseType
        >
      : References.GetAgentInstancesByWorkflowIdResponseType;
  };

export function useGetAgentInstancesByWorkflowIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentInstancesByWorkflowIdResponseType>,
    References.GetAgentInstancesByWorkflowIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentInstancesByWorkflowIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentInstancesByWorkflowId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentInstancesByWorkflowIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentInstancesByWorkflowIdSuspenseQueryReturn<T>;
}

type UseGetActiveAgentInstancesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetActiveAgentInstancesResponseType>,
    References.GetActiveAgentInstancesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getActiveAgentInstances',
            References.GetActiveAgentInstancesResponseType
          >
        : References.GetActiveAgentInstancesResponseType)
    | undefined;
};

export function useGetActiveAgentInstancesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetActiveAgentInstancesResponseType>,
    References.GetActiveAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetActiveAgentInstancesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_ACTIVE_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getActiveAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetActiveAgentInstancesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetActiveAgentInstancesQueryReturn<T>;
}

type UseGetActiveAgentInstancesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetActiveAgentInstancesResponseType>,
    References.GetActiveAgentInstancesRequestType,
    T extends true
      ? Record<
          'getActiveAgentInstances',
          References.GetActiveAgentInstancesResponseType
        >
      : References.GetActiveAgentInstancesResponseType
  >;

export function useGetActiveAgentInstancesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetActiveAgentInstancesResponseType>,
    References.GetActiveAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetActiveAgentInstancesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_ACTIVE_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getActiveAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetActiveAgentInstancesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetActiveAgentInstancesLazyQueryReturn<T>;
}

type UseGetActiveAgentInstancesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetActiveAgentInstancesResponseType>,
    References.GetActiveAgentInstancesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getActiveAgentInstances',
        References.GetActiveAgentInstancesResponseType
      >
    : References.GetActiveAgentInstancesResponseType;
};

export function useGetActiveAgentInstancesSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetActiveAgentInstancesResponseType>,
    References.GetActiveAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetActiveAgentInstancesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_ACTIVE_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getActiveAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetActiveAgentInstancesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetActiveAgentInstancesSuspenseQueryReturn<T>;
}

type UseListAgentInstancesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListAgentInstancesResponseType>,
    References.ListAgentInstancesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listAgentInstances',
            References.ListAgentInstancesResponseType
          >
        : References.ListAgentInstancesResponseType)
    | undefined;
};

export function useListAgentInstancesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListAgentInstancesResponseType>,
    References.ListAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListAgentInstancesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListAgentInstancesQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseListAgentInstancesQueryReturn<T>;
}

type UseListAgentInstancesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListAgentInstancesResponseType>,
    References.ListAgentInstancesRequestType,
    T extends true
      ? Record<'listAgentInstances', References.ListAgentInstancesResponseType>
      : References.ListAgentInstancesResponseType
  >;

export function useListAgentInstancesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListAgentInstancesResponseType>,
    References.ListAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListAgentInstancesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListAgentInstancesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListAgentInstancesLazyQueryReturn<T>;
}

type UseListAgentInstancesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListAgentInstancesResponseType>,
    References.ListAgentInstancesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'listAgentInstances', References.ListAgentInstancesResponseType>
    : References.ListAgentInstancesResponseType;
};

export function useListAgentInstancesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListAgentInstancesResponseType>,
    References.ListAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListAgentInstancesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListAgentInstancesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListAgentInstancesSuspenseQueryReturn<T>;
}

type UseSearchAgentInstancesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SearchAgentInstancesResponseType>,
    References.SearchAgentInstancesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'searchAgentInstances',
            References.SearchAgentInstancesResponseType
          >
        : References.SearchAgentInstancesResponseType)
    | undefined;
};

export function useSearchAgentInstancesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SearchAgentInstancesResponseType>,
    References.SearchAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchAgentInstancesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.SEARCH_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchAgentInstancesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchAgentInstancesQueryReturn<T>;
}

type UseSearchAgentInstancesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.SearchAgentInstancesResponseType>,
    References.SearchAgentInstancesRequestType,
    T extends true
      ? Record<
          'searchAgentInstances',
          References.SearchAgentInstancesResponseType
        >
      : References.SearchAgentInstancesResponseType
  >;

export function useSearchAgentInstancesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SearchAgentInstancesResponseType>,
    References.SearchAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchAgentInstancesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEARCH_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSearchAgentInstancesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSearchAgentInstancesLazyQueryReturn<T>;
}

type UseSearchAgentInstancesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SearchAgentInstancesResponseType>,
    References.SearchAgentInstancesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'searchAgentInstances',
        References.SearchAgentInstancesResponseType
      >
    : References.SearchAgentInstancesResponseType;
};

export function useSearchAgentInstancesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SearchAgentInstancesResponseType>,
    References.SearchAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchAgentInstancesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.SEARCH_AGENT_INSTANCES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            searchAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchAgentInstancesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchAgentInstancesSuspenseQueryReturn<T>;
}

type UseCreateAgentInstanceMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CreateAgentInstanceResponseType>,
    References.CreateAgentInstanceRequestType,
    T extends true
      ? Record<
          'createAgentInstance',
          References.CreateAgentInstanceResponseType
        >
      : References.CreateAgentInstanceResponseType
  >;

export function useCreateAgentInstanceMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateAgentInstanceResponseType>,
    References.CreateAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateAgentInstanceMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_AGENT_INSTANCE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateAgentInstanceMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateAgentInstanceMutationReturn<T>;
}

type UseUpdateAgentInstanceV2MutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAgentInstanceV2ResponseType>,
    References.UpdateAgentInstanceV2RequestType,
    T extends true
      ? Record<
          'updateAgentInstanceV2',
          References.UpdateAgentInstanceV2ResponseType
        >
      : References.UpdateAgentInstanceV2ResponseType
  >;

export function useUpdateAgentInstanceV2Mutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAgentInstanceV2ResponseType>,
    References.UpdateAgentInstanceV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAgentInstanceV2MutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_AGENT_INSTANCE_V2_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAgentInstanceV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAgentInstanceV2MutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAgentInstanceV2MutationReturn<T>;
}

type UseUpdateAgentInstanceV3MutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAgentInstanceV3ResponseType>,
    References.UpdateAgentInstanceV3RequestType,
    T extends true
      ? Record<
          'updateAgentInstanceV3',
          References.UpdateAgentInstanceV3ResponseType
        >
      : References.UpdateAgentInstanceV3ResponseType
  >;

export function useUpdateAgentInstanceV3Mutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAgentInstanceV3ResponseType>,
    References.UpdateAgentInstanceV3RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAgentInstanceV3MutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_AGENT_INSTANCE_V3_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAgentInstanceV3: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAgentInstanceV3MutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAgentInstanceV3MutationReturn<T>;
}

type UsePatchAgentInstanceMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.PatchAgentInstanceResponseType>,
    References.PatchAgentInstanceRequestType,
    T extends true
      ? Record<'patchAgentInstance', References.PatchAgentInstanceResponseType>
      : References.PatchAgentInstanceResponseType
  >;

export function usePatchAgentInstanceMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.PatchAgentInstanceResponseType>,
    References.PatchAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePatchAgentInstanceMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PATCH_AGENT_INSTANCE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            patchAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePatchAgentInstanceMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePatchAgentInstanceMutationReturn<T>;
}

type UseUpdateAgentMetadataMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAgentMetadataResponseType>,
    References.UpdateAgentMetadataRequestType,
    T extends true
      ? Record<
          'updateAgentMetadata',
          References.UpdateAgentMetadataResponseType
        >
      : References.UpdateAgentMetadataResponseType
  >;

export function useUpdateAgentMetadataMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAgentMetadataResponseType>,
    References.UpdateAgentMetadataRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAgentMetadataMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_AGENT_METADATA_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAgentMetadata: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAgentMetadataMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAgentMetadataMutationReturn<T>;
}

type UseUpdateAgentAvailabilityMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAgentAvailabilityResponseType>,
    References.UpdateAgentAvailabilityRequestType,
    T extends true
      ? Record<
          'updateAgentAvailability',
          References.UpdateAgentAvailabilityResponseType
        >
      : References.UpdateAgentAvailabilityResponseType
  >;

export function useUpdateAgentAvailabilityMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAgentAvailabilityResponseType>,
    References.UpdateAgentAvailabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAgentAvailabilityMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_AGENT_AVAILABILITY_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAgentAvailability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAgentAvailabilityMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAgentAvailabilityMutationReturn<T>;
}

type UseUnpublishAgentInstanceMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UnpublishAgentInstanceResponseType>,
    References.UnpublishAgentInstanceRequestType,
    T extends true
      ? Record<
          'unpublishAgentInstance',
          References.UnpublishAgentInstanceResponseType
        >
      : References.UnpublishAgentInstanceResponseType
  >;

export function useUnpublishAgentInstanceMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UnpublishAgentInstanceResponseType>,
    References.UnpublishAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUnpublishAgentInstanceMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UNPUBLISH_AGENT_INSTANCE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            unpublishAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUnpublishAgentInstanceMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUnpublishAgentInstanceMutationReturn<T>;
}

type UseResetToLatestTemplateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.ResetToLatestTemplateResponseType>,
    References.ResetToLatestTemplateRequestType,
    T extends true
      ? Record<
          'resetToLatestTemplate',
          References.ResetToLatestTemplateResponseType
        >
      : References.ResetToLatestTemplateResponseType
  >;

export function useResetToLatestTemplateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.ResetToLatestTemplateResponseType>,
    References.ResetToLatestTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResetToLatestTemplateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.RESET_TO_LATEST_TEMPLATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            resetToLatestTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseResetToLatestTemplateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseResetToLatestTemplateMutationReturn<T>;
}

type UseSoftDeleteAgentInstanceMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SoftDeleteAgentInstanceResponseType>,
    References.SoftDeleteAgentInstanceRequestType,
    T extends true
      ? Record<
          'softDeleteAgentInstance',
          References.SoftDeleteAgentInstanceResponseType
        >
      : References.SoftDeleteAgentInstanceResponseType
  >;

export function useSoftDeleteAgentInstanceMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SoftDeleteAgentInstanceResponseType>,
    References.SoftDeleteAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSoftDeleteAgentInstanceMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SOFT_DELETE_AGENT_INSTANCE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            softDeleteAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSoftDeleteAgentInstanceMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSoftDeleteAgentInstanceMutationReturn<T>;
}

type UseSoftDeleteAgentInstanceV2MutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SoftDeleteAgentInstanceV2ResponseType>,
    References.SoftDeleteAgentInstanceV2RequestType,
    T extends true
      ? Record<
          'softDeleteAgentInstanceV2',
          References.SoftDeleteAgentInstanceV2ResponseType
        >
      : References.SoftDeleteAgentInstanceV2ResponseType
  >;

export function useSoftDeleteAgentInstanceV2Mutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SoftDeleteAgentInstanceV2ResponseType>,
    References.SoftDeleteAgentInstanceV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSoftDeleteAgentInstanceV2MutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            softDeleteAgentInstanceV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSoftDeleteAgentInstanceV2MutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSoftDeleteAgentInstanceV2MutationReturn<T>;
}

type UseCreateInstanceFromTemplateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CreateInstanceFromTemplateResponseType>,
    References.CreateInstanceFromTemplateRequestType,
    T extends true
      ? Record<
          'createInstanceFromTemplate',
          References.CreateInstanceFromTemplateResponseType
        >
      : References.CreateInstanceFromTemplateResponseType
  >;

export function useCreateInstanceFromTemplateMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.CreateInstanceFromTemplateResponseType>,
    References.CreateInstanceFromTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateInstanceFromTemplateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_INSTANCE_FROM_TEMPLATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createInstanceFromTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateInstanceFromTemplateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateInstanceFromTemplateMutationReturn<T>;
}

type UseCreateInstanceFromTemplateByGlobalIdMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<
      'result',
      References.CreateInstanceFromTemplateByGlobalIdResponseType
    >,
    References.CreateInstanceFromTemplateByGlobalIdRequestType,
    T extends true
      ? Record<
          'createInstanceFromTemplateByGlobalId',
          References.CreateInstanceFromTemplateByGlobalIdResponseType
        >
      : References.CreateInstanceFromTemplateByGlobalIdResponseType
  >;

export function useCreateInstanceFromTemplateByGlobalIdMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<
      'result',
      References.CreateInstanceFromTemplateByGlobalIdResponseType
    >,
    References.CreateInstanceFromTemplateByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateInstanceFromTemplateByGlobalIdMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createInstanceFromTemplateByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateInstanceFromTemplateByGlobalIdMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateInstanceFromTemplateByGlobalIdMutationReturn<T>;
}

type UseCloneAgentInstanceMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CloneAgentInstanceResponseType>,
    References.CloneAgentInstanceRequestType,
    T extends true
      ? Record<'cloneAgentInstance', References.CloneAgentInstanceResponseType>
      : References.CloneAgentInstanceResponseType
  >;

export function useCloneAgentInstanceMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CloneAgentInstanceResponseType>,
    References.CloneAgentInstanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCloneAgentInstanceMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CLONE_AGENT_INSTANCE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            cloneAgentInstance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCloneAgentInstanceMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCloneAgentInstanceMutationReturn<T>;
}

type UseCloneAgentsForFlowMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CloneAgentsForFlowResponseType>,
    References.CloneAgentsForFlowRequestType,
    T extends true
      ? Record<'cloneAgentsForFlow', References.CloneAgentsForFlowResponseType>
      : References.CloneAgentsForFlowResponseType
  >;

export function useCloneAgentsForFlowMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CloneAgentsForFlowResponseType>,
    References.CloneAgentsForFlowRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCloneAgentsForFlowMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CLONE_AGENTS_FOR_FLOW_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            cloneAgentsForFlow: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCloneAgentsForFlowMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCloneAgentsForFlowMutationReturn<T>;
}

type UseGetInstancesByTemplateIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstancesByTemplateIdsResponseType>,
    References.GetInstancesByTemplateIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getInstancesByTemplateIds',
            References.GetInstancesByTemplateIdsResponseType
          >
        : References.GetInstancesByTemplateIdsResponseType)
    | undefined;
};

export function useGetInstancesByTemplateIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstancesByTemplateIdsResponseType>,
    References.GetInstancesByTemplateIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstancesByTemplateIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_INSTANCES_BY_TEMPLATE_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstancesByTemplateIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstancesByTemplateIdsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstancesByTemplateIdsQueryReturn<T>;
}

type UseGetInstancesByTemplateIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstancesByTemplateIdsResponseType>,
    References.GetInstancesByTemplateIdsRequestType,
    T extends true
      ? Record<
          'getInstancesByTemplateIds',
          References.GetInstancesByTemplateIdsResponseType
        >
      : References.GetInstancesByTemplateIdsResponseType
  >;

export function useGetInstancesByTemplateIdsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstancesByTemplateIdsResponseType>,
    References.GetInstancesByTemplateIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstancesByTemplateIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTANCES_BY_TEMPLATE_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstancesByTemplateIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstancesByTemplateIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstancesByTemplateIdsLazyQueryReturn<T>;
}

type UseGetInstancesByTemplateIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstancesByTemplateIdsResponseType>,
    References.GetInstancesByTemplateIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getInstancesByTemplateIds',
        References.GetInstancesByTemplateIdsResponseType
      >
    : References.GetInstancesByTemplateIdsResponseType;
};

export function useGetInstancesByTemplateIdsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstancesByTemplateIdsResponseType>,
    References.GetInstancesByTemplateIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstancesByTemplateIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTANCES_BY_TEMPLATE_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstancesByTemplateIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstancesByTemplateIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstancesByTemplateIdsSuspenseQueryReturn<T>;
}

type UseGetInstancesByGlobalIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstancesByGlobalIdResponseType>,
    References.GetInstancesByGlobalIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getInstancesByGlobalId',
            References.GetInstancesByGlobalIdResponseType
          >
        : References.GetInstancesByGlobalIdResponseType)
    | undefined;
};

export function useGetInstancesByGlobalIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstancesByGlobalIdResponseType>,
    References.GetInstancesByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstancesByGlobalIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_INSTANCES_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstancesByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstancesByGlobalIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstancesByGlobalIdQueryReturn<T>;
}

type UseGetInstancesByGlobalIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstancesByGlobalIdResponseType>,
    References.GetInstancesByGlobalIdRequestType,
    T extends true
      ? Record<
          'getInstancesByGlobalId',
          References.GetInstancesByGlobalIdResponseType
        >
      : References.GetInstancesByGlobalIdResponseType
  >;

export function useGetInstancesByGlobalIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstancesByGlobalIdResponseType>,
    References.GetInstancesByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstancesByGlobalIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTANCES_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstancesByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstancesByGlobalIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstancesByGlobalIdLazyQueryReturn<T>;
}

type UseGetInstancesByGlobalIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstancesByGlobalIdResponseType>,
    References.GetInstancesByGlobalIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getInstancesByGlobalId',
        References.GetInstancesByGlobalIdResponseType
      >
    : References.GetInstancesByGlobalIdResponseType;
};

export function useGetInstancesByGlobalIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstancesByGlobalIdResponseType>,
    References.GetInstancesByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstancesByGlobalIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTANCES_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstancesByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstancesByGlobalIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstancesByGlobalIdSuspenseQueryReturn<T>;
}

type UseUpdateAgentInstanceOwnerMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAgentInstanceOwnerResponseType>,
    References.UpdateAgentInstanceOwnerRequestType,
    T extends true
      ? Record<
          'updateAgentInstanceOwner',
          References.UpdateAgentInstanceOwnerResponseType
        >
      : References.UpdateAgentInstanceOwnerResponseType
  >;

export function useUpdateAgentInstanceOwnerMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAgentInstanceOwnerResponseType>,
    References.UpdateAgentInstanceOwnerRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAgentInstanceOwnerMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_AGENT_INSTANCE_OWNER_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAgentInstanceOwner: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAgentInstanceOwnerMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAgentInstanceOwnerMutationReturn<T>;
}

type UseUpdateAgentInstanceFromSnapshotMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAgentInstanceFromSnapshotResponseType>,
    References.UpdateAgentInstanceFromSnapshotRequestType,
    T extends true
      ? Record<
          'updateAgentInstanceFromSnapshot',
          References.UpdateAgentInstanceFromSnapshotResponseType
        >
      : References.UpdateAgentInstanceFromSnapshotResponseType
  >;

export function useUpdateAgentInstanceFromSnapshotMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAgentInstanceFromSnapshotResponseType>,
    References.UpdateAgentInstanceFromSnapshotRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAgentInstanceFromSnapshotMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAgentInstanceFromSnapshot: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAgentInstanceFromSnapshotMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAgentInstanceFromSnapshotMutationReturn<T>;
}

type UseCloneInstanceFromSnapshotMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CloneInstanceFromSnapshotResponseType>,
    References.CloneInstanceFromSnapshotRequestType,
    T extends true
      ? Record<
          'cloneInstanceFromSnapshot',
          References.CloneInstanceFromSnapshotResponseType
        >
      : References.CloneInstanceFromSnapshotResponseType
  >;

export function useCloneInstanceFromSnapshotMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CloneInstanceFromSnapshotResponseType>,
    References.CloneInstanceFromSnapshotRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCloneInstanceFromSnapshotMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            cloneInstanceFromSnapshot: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCloneInstanceFromSnapshotMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCloneInstanceFromSnapshotMutationReturn<T>;
}

type UseValidateAgentInstanceReadinessQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ValidateAgentInstanceReadinessResponseType>,
    References.ValidateAgentInstanceReadinessRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'validateAgentInstanceReadiness',
            References.ValidateAgentInstanceReadinessResponseType
          >
        : References.ValidateAgentInstanceReadinessResponseType)
    | undefined;
};

export function useValidateAgentInstanceReadinessQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.ValidateAgentInstanceReadinessResponseType>,
    References.ValidateAgentInstanceReadinessRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseValidateAgentInstanceReadinessQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.VALIDATE_AGENT_INSTANCE_READINESS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            validateAgentInstanceReadiness: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseValidateAgentInstanceReadinessQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseValidateAgentInstanceReadinessQueryReturn<T>;
}

type UseValidateAgentInstanceReadinessLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ValidateAgentInstanceReadinessResponseType>,
    References.ValidateAgentInstanceReadinessRequestType,
    T extends true
      ? Record<
          'validateAgentInstanceReadiness',
          References.ValidateAgentInstanceReadinessResponseType
        >
      : References.ValidateAgentInstanceReadinessResponseType
  >;

export function useValidateAgentInstanceReadinessLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ValidateAgentInstanceReadinessResponseType>,
    References.ValidateAgentInstanceReadinessRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseValidateAgentInstanceReadinessLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.VALIDATE_AGENT_INSTANCE_READINESS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            validateAgentInstanceReadiness: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseValidateAgentInstanceReadinessLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseValidateAgentInstanceReadinessLazyQueryReturn<T>;
}

type UseValidateAgentInstanceReadinessSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.ValidateAgentInstanceReadinessResponseType>,
      References.ValidateAgentInstanceReadinessRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'validateAgentInstanceReadiness',
          References.ValidateAgentInstanceReadinessResponseType
        >
      : References.ValidateAgentInstanceReadinessResponseType;
  };

export function useValidateAgentInstanceReadinessSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ValidateAgentInstanceReadinessResponseType>,
    References.ValidateAgentInstanceReadinessRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseValidateAgentInstanceReadinessSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.VALIDATE_AGENT_INSTANCE_READINESS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            validateAgentInstanceReadiness: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseValidateAgentInstanceReadinessSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseValidateAgentInstanceReadinessSuspenseQueryReturn<T>;
}

type UseValidateAgentInstanceReadinessV2QueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ValidateAgentInstanceReadinessV2ResponseType>,
    References.ValidateAgentInstanceReadinessV2RequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'validateAgentInstanceReadinessV2',
            References.ValidateAgentInstanceReadinessV2ResponseType
          >
        : References.ValidateAgentInstanceReadinessV2ResponseType)
    | undefined;
};

export function useValidateAgentInstanceReadinessV2Query<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.ValidateAgentInstanceReadinessV2ResponseType>,
    References.ValidateAgentInstanceReadinessV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseValidateAgentInstanceReadinessV2QueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            validateAgentInstanceReadinessV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseValidateAgentInstanceReadinessV2QueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseValidateAgentInstanceReadinessV2QueryReturn<T>;
}

type UseValidateAgentInstanceReadinessV2LazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ValidateAgentInstanceReadinessV2ResponseType>,
    References.ValidateAgentInstanceReadinessV2RequestType,
    T extends true
      ? Record<
          'validateAgentInstanceReadinessV2',
          References.ValidateAgentInstanceReadinessV2ResponseType
        >
      : References.ValidateAgentInstanceReadinessV2ResponseType
  >;

export function useValidateAgentInstanceReadinessV2LazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ValidateAgentInstanceReadinessV2ResponseType>,
    References.ValidateAgentInstanceReadinessV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseValidateAgentInstanceReadinessV2LazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            validateAgentInstanceReadinessV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseValidateAgentInstanceReadinessV2LazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseValidateAgentInstanceReadinessV2LazyQueryReturn<T>;
}

type UseValidateAgentInstanceReadinessV2SuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.ValidateAgentInstanceReadinessV2ResponseType>,
      References.ValidateAgentInstanceReadinessV2RequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'validateAgentInstanceReadinessV2',
          References.ValidateAgentInstanceReadinessV2ResponseType
        >
      : References.ValidateAgentInstanceReadinessV2ResponseType;
  };

export function useValidateAgentInstanceReadinessV2SuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ValidateAgentInstanceReadinessV2ResponseType>,
    References.ValidateAgentInstanceReadinessV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseValidateAgentInstanceReadinessV2SuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            validateAgentInstanceReadinessV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseValidateAgentInstanceReadinessV2SuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseValidateAgentInstanceReadinessV2SuspenseQueryReturn<T>;
}

type UseBulkValidateAgentInstancesReadinessQueryReturn<T extends boolean> =
  Omit<
    QueryResult<
      Record<
        'result',
        References.BulkValidateAgentInstancesReadinessResponseType
      >,
      References.BulkValidateAgentInstancesReadinessRequestType
    >,
    'data'
  > & {
    data:
      | (T extends true
          ? Record<
              'bulkValidateAgentInstancesReadiness',
              References.BulkValidateAgentInstancesReadinessResponseType
            >
          : References.BulkValidateAgentInstancesReadinessResponseType)
      | undefined;
  };

export function useBulkValidateAgentInstancesReadinessQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.BulkValidateAgentInstancesReadinessResponseType
    >,
    References.BulkValidateAgentInstancesReadinessRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseBulkValidateAgentInstancesReadinessQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            bulkValidateAgentInstancesReadiness: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseBulkValidateAgentInstancesReadinessQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseBulkValidateAgentInstancesReadinessQueryReturn<T>;
}

type UseBulkValidateAgentInstancesReadinessLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<
      'result',
      References.BulkValidateAgentInstancesReadinessResponseType
    >,
    References.BulkValidateAgentInstancesReadinessRequestType,
    T extends true
      ? Record<
          'bulkValidateAgentInstancesReadiness',
          References.BulkValidateAgentInstancesReadinessResponseType
        >
      : References.BulkValidateAgentInstancesReadinessResponseType
  >;

export function useBulkValidateAgentInstancesReadinessLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.BulkValidateAgentInstancesReadinessResponseType
    >,
    References.BulkValidateAgentInstancesReadinessRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseBulkValidateAgentInstancesReadinessLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            bulkValidateAgentInstancesReadiness: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseBulkValidateAgentInstancesReadinessLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseBulkValidateAgentInstancesReadinessLazyQueryReturn<T>;
}

type UseBulkValidateAgentInstancesReadinessSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.BulkValidateAgentInstancesReadinessResponseType
    >,
    References.BulkValidateAgentInstancesReadinessRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'bulkValidateAgentInstancesReadiness',
        References.BulkValidateAgentInstancesReadinessResponseType
      >
    : References.BulkValidateAgentInstancesReadinessResponseType;
};

export function useBulkValidateAgentInstancesReadinessSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.BulkValidateAgentInstancesReadinessResponseType
    >,
    References.BulkValidateAgentInstancesReadinessRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseBulkValidateAgentInstancesReadinessSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            bulkValidateAgentInstancesReadiness: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseBulkValidateAgentInstancesReadinessSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseBulkValidateAgentInstancesReadinessSuspenseQueryReturn<T>;
}

type UseBulkCreateAgentInstancesMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.BulkCreateAgentInstancesResponseType>,
    References.BulkCreateAgentInstancesRequestType,
    T extends true
      ? Record<
          'bulkCreateAgentInstances',
          References.BulkCreateAgentInstancesResponseType
        >
      : References.BulkCreateAgentInstancesResponseType
  >;

export function useBulkCreateAgentInstancesMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.BulkCreateAgentInstancesResponseType>,
    References.BulkCreateAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseBulkCreateAgentInstancesMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.BULK_CREATE_AGENT_INSTANCES_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            bulkCreateAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseBulkCreateAgentInstancesMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseBulkCreateAgentInstancesMutationReturn<T>;
}

type UseBulkCreateAgentInstancesByKeyMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.BulkCreateAgentInstancesByKeyResponseType>,
    References.BulkCreateAgentInstancesByKeyRequestType,
    T extends true
      ? Record<
          'bulkCreateAgentInstancesByKey',
          References.BulkCreateAgentInstancesByKeyResponseType
        >
      : References.BulkCreateAgentInstancesByKeyResponseType
  >;

export function useBulkCreateAgentInstancesByKeyMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.BulkCreateAgentInstancesByKeyResponseType>,
    References.BulkCreateAgentInstancesByKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseBulkCreateAgentInstancesByKeyMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            bulkCreateAgentInstancesByKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseBulkCreateAgentInstancesByKeyMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseBulkCreateAgentInstancesByKeyMutationReturn<T>;
}

type UseBulkSoftDeleteAgentInstancesMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.BulkSoftDeleteAgentInstancesResponseType>,
    References.BulkSoftDeleteAgentInstancesRequestType,
    T extends true
      ? Record<
          'bulkSoftDeleteAgentInstances',
          References.BulkSoftDeleteAgentInstancesResponseType
        >
      : References.BulkSoftDeleteAgentInstancesResponseType
  >;

export function useBulkSoftDeleteAgentInstancesMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.BulkSoftDeleteAgentInstancesResponseType>,
    References.BulkSoftDeleteAgentInstancesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseBulkSoftDeleteAgentInstancesMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            bulkSoftDeleteAgentInstances: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseBulkSoftDeleteAgentInstancesMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseBulkSoftDeleteAgentInstancesMutationReturn<T>;
}

type UseGetAgentConnectionsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAgentConnectionsResponseType>,
    References.GetAgentConnectionsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAgentConnections',
            References.GetAgentConnectionsResponseType
          >
        : References.GetAgentConnectionsResponseType)
    | undefined;
};

export function useGetAgentConnectionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAgentConnectionsResponseType>,
    References.GetAgentConnectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentConnectionsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AGENT_CONNECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentConnections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentConnectionsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentConnectionsQueryReturn<T>;
}

type UseGetAgentConnectionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAgentConnectionsResponseType>,
    References.GetAgentConnectionsRequestType,
    T extends true
      ? Record<
          'getAgentConnections',
          References.GetAgentConnectionsResponseType
        >
      : References.GetAgentConnectionsResponseType
  >;

export function useGetAgentConnectionsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAgentConnectionsResponseType>,
    References.GetAgentConnectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentConnectionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AGENT_CONNECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAgentConnections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAgentConnectionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAgentConnectionsLazyQueryReturn<T>;
}

type UseGetAgentConnectionsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAgentConnectionsResponseType>,
    References.GetAgentConnectionsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getAgentConnections', References.GetAgentConnectionsResponseType>
    : References.GetAgentConnectionsResponseType;
};

export function useGetAgentConnectionsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAgentConnectionsResponseType>,
    References.GetAgentConnectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAgentConnectionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AGENT_CONNECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAgentConnections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAgentConnectionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAgentConnectionsSuspenseQueryReturn<T>;
}

type UseGetGlobalAgentConnectionsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetGlobalAgentConnectionsResponseType>,
    References.GetGlobalAgentConnectionsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getGlobalAgentConnections',
            References.GetGlobalAgentConnectionsResponseType
          >
        : References.GetGlobalAgentConnectionsResponseType)
    | undefined;
};

export function useGetGlobalAgentConnectionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetGlobalAgentConnectionsResponseType>,
    References.GetGlobalAgentConnectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetGlobalAgentConnectionsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_GLOBAL_AGENT_CONNECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getGlobalAgentConnections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetGlobalAgentConnectionsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetGlobalAgentConnectionsQueryReturn<T>;
}

type UseGetGlobalAgentConnectionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetGlobalAgentConnectionsResponseType>,
    References.GetGlobalAgentConnectionsRequestType,
    T extends true
      ? Record<
          'getGlobalAgentConnections',
          References.GetGlobalAgentConnectionsResponseType
        >
      : References.GetGlobalAgentConnectionsResponseType
  >;

export function useGetGlobalAgentConnectionsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetGlobalAgentConnectionsResponseType>,
    References.GetGlobalAgentConnectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetGlobalAgentConnectionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_GLOBAL_AGENT_CONNECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getGlobalAgentConnections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetGlobalAgentConnectionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetGlobalAgentConnectionsLazyQueryReturn<T>;
}

type UseGetGlobalAgentConnectionsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetGlobalAgentConnectionsResponseType>,
    References.GetGlobalAgentConnectionsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getGlobalAgentConnections',
        References.GetGlobalAgentConnectionsResponseType
      >
    : References.GetGlobalAgentConnectionsResponseType;
};

export function useGetGlobalAgentConnectionsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetGlobalAgentConnectionsResponseType>,
    References.GetGlobalAgentConnectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetGlobalAgentConnectionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_GLOBAL_AGENT_CONNECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getGlobalAgentConnections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetGlobalAgentConnectionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetGlobalAgentConnectionsSuspenseQueryReturn<T>;
}

type UseListAgentInstancesWithInvocabilityQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListAgentInstancesWithInvocabilityResponseType>,
    References.ListAgentInstancesWithInvocabilityRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listAgentInstancesWithInvocability',
            References.ListAgentInstancesWithInvocabilityResponseType
          >
        : References.ListAgentInstancesWithInvocabilityResponseType)
    | undefined;
};

export function useListAgentInstancesWithInvocabilityQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.ListAgentInstancesWithInvocabilityResponseType>,
    References.ListAgentInstancesWithInvocabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListAgentInstancesWithInvocabilityQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listAgentInstancesWithInvocability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListAgentInstancesWithInvocabilityQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListAgentInstancesWithInvocabilityQueryReturn<T>;
}

type UseListAgentInstancesWithInvocabilityLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListAgentInstancesWithInvocabilityResponseType>,
    References.ListAgentInstancesWithInvocabilityRequestType,
    T extends true
      ? Record<
          'listAgentInstancesWithInvocability',
          References.ListAgentInstancesWithInvocabilityResponseType
        >
      : References.ListAgentInstancesWithInvocabilityResponseType
  >;

export function useListAgentInstancesWithInvocabilityLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListAgentInstancesWithInvocabilityResponseType>,
    References.ListAgentInstancesWithInvocabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListAgentInstancesWithInvocabilityLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listAgentInstancesWithInvocability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListAgentInstancesWithInvocabilityLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListAgentInstancesWithInvocabilityLazyQueryReturn<T>;
}

type UseListAgentInstancesWithInvocabilitySuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListAgentInstancesWithInvocabilityResponseType>,
    References.ListAgentInstancesWithInvocabilityRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listAgentInstancesWithInvocability',
        References.ListAgentInstancesWithInvocabilityResponseType
      >
    : References.ListAgentInstancesWithInvocabilityResponseType;
};

export function useListAgentInstancesWithInvocabilitySuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListAgentInstancesWithInvocabilityResponseType>,
    References.ListAgentInstancesWithInvocabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListAgentInstancesWithInvocabilitySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listAgentInstancesWithInvocability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListAgentInstancesWithInvocabilitySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListAgentInstancesWithInvocabilitySuspenseQueryReturn<T>;
}
